@if (specialMenuGroups()?.length > 0) {
  <mat-nav-list>
    @for (menuGroup of specialMenuGroups(); track menuGroup.id) {
      <app-menu-group [menuGroup]="menuGroup"
        [selectedMenuItemId]="selectedMenuItemId()"
        [favorites]="favorites()"
        [isSelected]="menuGroup.id == selectedMenuGroupId()"
        [isWide]="isWide()"
        [isSpecial]="true"
        [isPopupEnabled]="isPopupEnabled()"
        [isFavoriteEnabled]="isAddFavoriteEnabled()"
        (menuGroupClick)="menuGroupClick.emit($event)"
        (menuItemClick)="menuItemClick.emit($event)"
        (menuItemAddedToFavorite)="menuItemAddedToFavorite.emit($event)"
        (menuItemRemovedFromFavorite)="menuItemRemovedFromFavorite.emit($event)" />
    }
  </mat-nav-list>
}

@if (menuGroups()?.length > 0) {
  <mat-nav-list>
    @for (menuGroup of menuGroups(); track menuGroup.id) {
      <app-menu-group [menuGroup]="menuGroup"
        [selectedMenuItemId]="selectedMenuItemId()"
        [favorites]="favorites()"
        [isSelected]="menuGroup.id == selectedMenuGroupId()"
        [isWide]="isWide()"
        [isPopupEnabled]="isPopupEnabled()"
        [isFavoriteEnabled]="isAddFavoriteEnabled()"
        (menuGroupClick)="menuGroupClick.emit($event)"
        (menuItemClick)="menuItemClick.emit($event)"
        (menuItemAddedToFavorite)="menuItemAddedToFavorite.emit($event)"
        (menuItemRemovedFromFavorite)="menuItemRemovedFromFavorite.emit($event)" />
    }
  </mat-nav-list>
}
